import { keyframes } from '@emotion/react';
import styled from '@emotion/styled/macro';
import { PageWrapper } from '../../../layout/components/Layout.styles';

export const LoadingDots = () => {
  return (
    <DotsContainer>
      <Dot />
      <Dot delay="0.2s" />
      <Dot delay="0.4s" />
    </DotsContainer>
  );
};

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  } 
  40% {
    transform: scale(1);
  }
`;

const DotsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
`;

const Dot = styled.div`
  width: 8px;
  height: 8px;
  margin: 0 4px;
  border-radius: 50%;
  background-color: #888;
  animation: ${bounce} 1s infinite ease-in-out;
  animation-delay: ${(props) => props.delay || '0s'};
`;

export const MobilePageWrapper = styled(PageWrapper)`
  height: calc(100vh - 128px);

  @supports (height: 100dvh) {
    height: calc(100dvh - 128px);
  }
  background: #f2f3f5;
  padding: 0;
`;